import React from 'react'

const ControlItem = ({title, text, children}) => {
    return (
        <div className='bg-itemControlBackground rounded-2xl w-full my-3 px-2 py-3 flex flex-col sm:flex-row '>
            <div className='flex flex-col w-full sm:w-[80%]'>
                <div className='truncate'>
                    {title}
                </div>
                <div className='break-words font-light'>
                    {text.slice(0, 150)}...
                </div>
            </div>
            <div className='mx-auto flex flex-row w-[60%] sm:w-[20%] justify-around'>
                {children}
            </div>
        </div>
    );
}
 
export default ControlItem;